// API Utility Functions
// Standardized functions for making backend API calls

// Helper function to safely get environment variables
const getEnvVar = (key, defaultValue = '') => {
  if (typeof process !== 'undefined' && process && process.env) {
    return process.env[key] || defaultValue;
  }
  return defaultValue;
};

// Standardized function to get API base URL
export const getApiBaseUrl = () => {
  const envUrl = getEnvVar('REACT_APP_ANALYSIS_API_URL', '/analysis-api');
  // If it's a full URL (starts with http), use it as is
  if (envUrl.startsWith('http')) {
    return envUrl;
  }
  // Otherwise, it's a relative path, use it as is
  return envUrl;
};

// Standardized function to make API calls to backend
export const makeApiCall = async (endpoint, data) => {
  const baseUrl = getApiBaseUrl();
  const response = await fetch(`${baseUrl}${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }

  const result = await response.json();
  
  if (result.success) {
    return result.data;
  } else {
    throw new Error(result.error || 'Unknown API error');
  }
};

// Standardized function to make API calls with custom options
export const makeApiCallWithOptions = async (endpoint, data, options = {}) => {
  const baseUrl = getApiBaseUrl();
  const response = await fetch(`${baseUrl}${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    },
    body: JSON.stringify(data),
    ...options
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }

  const result = await response.json();
  
  if (result.success) {
    return result.data;
  } else {
    throw new Error(result.error || 'Unknown API error');
  }
};
